import {
  GetAllManufacturerDiscountForProjectResponse,
  GetUserManufacturerDiscountResponse,
  ProjectManufacturerDiscount,
  UpdateUserManufacturerDiscountRequest
} from "src/model/api/manufacturer-discount.model";
import { LegacyAPIResponse } from 'src/model/api/legacy-api-response.model';
import { appApiSlice } from "src/api/app-ApiSlice";
import { TAG_GET_QUOTE } from "src/api/api-tags";
import {
  CreateUserManufacturerRequest,
  CreateUserManufacturerResponse,
  DeleteUserManufacturerRequest,
  DeleteUserManufacturerResponse,
  ManufacturerRecommendationResponse,
  UpdateUserManufacturerRequest,
  UpdateUserManufacturerResponse
} from "src/model/api/manufacturer-recommendation";

export const manufacturerDiscountApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateProjectManufacturerDiscount: builder.mutation<LegacyAPIResponse, ProjectManufacturerDiscount>({
      query(discountData: ProjectManufacturerDiscount) {
        return {
          url: 'v1/manufacturer-discount/update-project-manufacturer-discount',
          method: 'PUT',
          body: discountData
        }
      },
    }),
    getAllManufacturerDiscountForProject: builder.query<GetAllManufacturerDiscountForProjectResponse, number | void>({
      query(projectId: number) {
        return `v1/manufacturer-discount/get-all-manufacturer-discount-for-project?project_id=${projectId}`
      },
      providesTags: [TAG_GET_QUOTE],
    }),
    getManufacturerRecommendationForProject: builder.query<ManufacturerRecommendationResponse, number | void>({
      query(projectId: number) {
        return `v1/manufacturer-discount/get-manufacturer-recommendation-for-project?project_id=${projectId}`
      },
      providesTags: [TAG_GET_QUOTE],
    }),
    createUserManufacturer: builder.mutation<CreateUserManufacturerResponse, CreateUserManufacturerRequest>({
      query: (body) => ({
        url: 'v1/manufacturer-discount/create-user-manufacturer',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TAG_GET_QUOTE]
    }),
    updateUserManufacturer: builder.mutation<UpdateUserManufacturerResponse, UpdateUserManufacturerRequest>({
      query: (body) => ({
        url: 'v1/manufacturer-discount/update-user-manufacturer',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [TAG_GET_QUOTE],
    }),
    deleteUserManufacturer: builder.mutation<DeleteUserManufacturerResponse, DeleteUserManufacturerRequest>({
      query: (body) => ({
        url: 'v1/manufacturer-discount/delete-user-manufacturer',
        method: 'DELETE',
        body,
      }),
      invalidatesTags: [TAG_GET_QUOTE],
    }),
    // also tagged with TAG_GET_QUOTE so renaming or deleting a user manufacturer refreshes the names
    getUserManufacturerDiscount: builder.query<GetUserManufacturerDiscountResponse, void>({
      query: () => 'v1/manufacturer-discount/get-user-manufacturer-discount',
      providesTags: [TAG_GET_QUOTE],
      keepUnusedDataFor: 0,
    }),
    updateUserManufacturerDiscount: builder.mutation<LegacyAPIResponse, UpdateUserManufacturerDiscountRequest>({
      query: (body) => ({
        url: 'v1/manufacturer-discount/update-user-manufacturer-discount',
        method: 'PUT',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useUpdateProjectManufacturerDiscountMutation,
  useGetAllManufacturerDiscountForProjectQuery,
  useGetManufacturerRecommendationForProjectQuery,
  useCreateUserManufacturerMutation,
  useUpdateUserManufacturerMutation,
  useDeleteUserManufacturerMutation,
  useGetUserManufacturerDiscountQuery,
  useUpdateUserManufacturerDiscountMutation
} = manufacturerDiscountApiSlice;